module.exports = __webpack_public_path__ + "img/ruler.e7e6721b.svg";